import {inject, Injectable} from '@angular/core';
import {PriceLevelConfigCopyApiService} from "./price-level-config-copy-api.service";
import {CopyPriceLevelConfigParams} from "../types/price-level-config-copy.types";

@Injectable({
  providedIn: 'root'
})
export class PriceLevelConfigCopyService {
  private priceLevelConfigCopyApiService: PriceLevelConfigCopyApiService = inject(PriceLevelConfigCopyApiService);

  public copyPriceLevelConfig(params: CopyPriceLevelConfigParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.priceLevelConfigCopyApiService.copyPriceLevelConfig(params).subscribe({
        next: () => resolve(),
        error: () => reject()
      });
    });
  }
}
